import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import "./index.css";

const screenSizes = {
  big: 1600,
  medium: 768,
  small: 600,
  divide: 767.9,
};
const BannerWrapper = styled.div`
  width: 100%;
  background-size: cover;
  background-position-x: 50%;
  background-position-y: 50%;
  min-height: 26vh;
  overflow: hidden;
  border-bottom: 1px solid var(--gray-300);
  display: flex;
  position: relative;
  z-index: 2;

  @media (min-width: ${screenSizes.medium}px) {
    background-image: url(${props => props.imgBig});
  }
  @media screen and (max-width: ${screenSizes.divide}px) {
    background-image: url(${props => props.imgSmall});
    min-height: 16vh;
  }
  @media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px) {
      min-height: 16vh;
  }
`;

const BannerHeader = styled.h2`
  color: white;
  line-height: 1.5;
  background-color: hsl(0, 10%, 0%, .5);
  padding-left: 20px;
  padding-right: 20px;
  font-size: 2.3rem;

  @media (max-width: ${screenSizes.divide}px) {
    font-size: 1.5rem;
  }
`;

const certBanner = ({ imgPathMin, imgPathMax, certName, isCertificate }) => {
  return (
    <BannerWrapper 
      className="flex--center" 
      imgBig={imgPathMin} 
      imgSmall={imgPathMax}
    >
      <BannerHeader>
        {certName && certName} { isCertificate && 'Certificate' }
        </BannerHeader>
    </BannerWrapper>
  );
};

certBanner.prototype = {
  imgPathMin: PropTypes.string.isRequired,
  imgPathMax: PropTypes.string,
  certName: PropTypes.string,
  isCertificate: PropTypes.string,
};

export default certBanner


// WEBPACK FOOTER //
// ./src/Pages/Certificates/Components/Banner.js